<div class="thumbnail-chart-container">
  <ng-container *ngIf="!loading; else loadingTemplate">
    <ng-container *ngIf="barChartData?.length || lineChartData?.length; else empty">
      <div class="chart">
        <ng-container [ngSwitch]="chartType">
          <ng-container *ngSwitchCase="'bar'">
            <ngx-charts-bar-vertical-stacked
              *ngIf="!chart.showSCurve"
              [scheme]="colorScheme"
              [results]="barChartData"
              [barPadding]="1"
              [animations]="false"
              [tooltipDisabled]="true"
            ></ngx-charts-bar-vertical-stacked>
            <combo-chart-component
              *ngIf="chart.showSCurve"
              [scheme]="colorScheme"
              [lineScheme]="sCurveScheme"
              [results]="barChartData"
              [barPadding]="1"
              [animations]="false"
              [lineChart]="lineChartData"
              [tooltipDisabled]="true"
            >
            </combo-chart-component>
          </ng-container>
          <ngx-charts-line-chart
            *ngSwitchCase="'line'"
            [scheme]="colorScheme"
            [results]="lineChartData"
            [animations]="false"
            [tooltipDisabled]="true"
          ></ngx-charts-line-chart>
          <ngx-charts-area-chart-stacked
            *ngSwitchCase="'area'"
            [scheme]="colorScheme"
            [results]="lineChartData"
            [animations]="false"
            [tooltipDisabled]="true"
          ></ngx-charts-area-chart-stacked>
        </ng-container>
        <p class="default-paragraph chart-thumbnail-xlabel">{{ xLabel }}</p>
      </div>
    </ng-container>
  </ng-container>
</div>

<ng-template #loadingTemplate>
  <div class="loading">loading...</div>
</ng-template>

<ng-template #empty>
  <div class="empty">
    <i class="empty-icon"></i>
    <span i18n>No data to display</span>
  </div>
</ng-template>
